import { Component, OnInit, ViewChild } from '@angular/core';

import { Router, ActivatedRoute, Params } from '@angular/router';

import { TranslateService } from 'ng2-translate';
import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';
import { InlineEditorService } from '../../../shared/services/inline-editor.service';

import { WorkConstants } from '../work.const';
import { ObjectPipe } from '../pipes/object.pipe';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

declare var $: any;

@Component({
  selector: 'app-sprint',
  templateUrl: './sprint.component.html',
  providers: [ProjectsService]
})
export class SprintComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  isHiddenHalfOverlay: boolean = true;
  isShowStoryItem: boolean = false;
  projectId: number;
  sprintId: number;
  sprintData: any = {};
  private objectPipe = new ObjectPipe();

  subTasks: Array<Array<any>> = [];
  sprintBoard: any = [];
  isShowFaIcon: Array<boolean> = [];
  formData: any = {};

  workConstants: any = WorkConstants;
  taskId: number;
  timeLeft: number;

  styleDisplay: string = "none";
  sprintBoardtest: any = [];

  taskCount = 0;

  timeLine: any;

  burndown: any = {
    actual_line: [],
    ideal_line: [],
    spent_line: [],
    x_axis: []
  };

  public lineChartColors:Array<any> = [
    { 
      backgroundColor: 'rgba(57, 156, 58, 0.2)',
      borderColor: 'rgba(57, 156, 58, 1)'
    },
    { 
      backgroundColor: 'rgba(224, 21, 21, 0.2)',
      borderColor: 'rgba(224, 21, 21, 1)'
    },
    {
      backgroundColor: 'rgba(19, 68, 167, 0.2)',
      borderColor: 'rgba(19, 68, 167, 1)'
    }
  ];

  constructor(
    private projectsService: ProjectsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private inlineEditorService: InlineEditorService,
    private dragulaService: DragulaService
  ) {
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1));
    });
  }

  ngOnInit() {
    this.setUrlParams();
    this.getSprint(false);
    this.getFormdata();
    this.getSprintBoard();
  }

  onDrop(args) {
    let [e, target, source] = args;
    let item = {
      id: e.dataset.itemid,
      ver_id: e.dataset.itemversion
    }
    this.updateTask(item, target.id, -1);
  }

  startSprintToggle(toggle) {
    let body = {};
    body['action'] = toggle;
    this.projectsService.startSprintToggle(this.sprintId, body).subscribe(
      res => {
        if (res) {
          this.getSprint(false);
        }
      }
    );
  }

  /**
   * lineChart
   */
  public lineChartData: Array<any> = [
    { data: this.burndown.ideal_line, label: 'Ideal velocity', lineTension: 0, fill: false },
    { data: this.burndown.actual_line, label: 'Left time', lineTension: 0, fill: false },
    { data: this.burndown.spent_line, label: 'Spent time', lineTension: 0, fill: false },
  ];

  public lineChartLabels: Array<any> = [];

  public lineChartOptions: any = {
    responsive: true,
  };

  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';
  // lineChart end

  getSprintBundrownChart() {
    this.projectsService.getSprintBundrownChart(this.sprintId).subscribe(
      res => {
        if (res) {
          this.burndown = res.data;
          this.lineChartData = [
            { data: this.burndown.ideal_line, label: 'Ideal velocity', lineTension: 0, fill: false },
            { data: this.burndown.actual_line, label: 'Left time', lineTension: 0, fill: false },
            { data: this.burndown.spent_line, label: 'Spent time', lineTension: 0, fill: false },
          ];
          this.lineChartLabels = this.burndown.x_axis;
          if (this.chart && this.chart.chart && this.chart.chart.config) {
            this.chart.chart.config.data.labels = this.burndown.x_axis;
            this.chart.chart.update();
          }
        }
      }
    );
  }

  // events
  public chartClicked(e: any): void {
    console.log('chartClicked',e);
  }

  public chartHovered(e: any): void {
    console.log('chartHovered',e);
  }
  
  setUrlParams() {
    this.activatedRoute.params.subscribe(
      (param: any) => {
        this.projectId = param.projectId ? param.projectId : -1;
        this.sprintId = param.id ? param.id : -1;
      });
  }

  setIsHiddenHalfOverlay(isHidden) {
    this.isHiddenHalfOverlay = isHidden;
  }

  openBacklog() {
    this.styleDisplay = this.styleDisplay === 'none' ? 'block' : 'none';
  }

  getSubTasks(storyId, index, isReset) {
    if (this.subTasks[index] && !isReset) {
      this.subTasks[index] = null;
      this.isShowFaIcon[index] = false;
    } else {
      this.projectsService.getSubTasks(storyId).subscribe(
        subTasks => {
          this.subTasks[index] = subTasks.data;
          if (subTasks.data.length <= 0) {
            this.alertService.warning({ title: this.translate.instant("WARNING"), msg: this.translate.instant('STORY_TASK_ARE_NOT_DEFINED') });
          } else {
            this.isShowFaIcon[index] = true;
          }
        }
      );
    }
  }

  getBacklogData(event) {
    if (event && event !== -1) {
      this.getSprint(true);
      this.getSubTasks(event.id, event.i, true);
    } else {
      if (event === -1) {
        this.getSprintBoard();
      } else {
        this.getSprint(true);
      }
    }
  }

  getSprint(isFormData) {
    //this.subTasks = [];
    //this.isShowFaIcon = [];
    this.projectsService.getSprint(this.projectId, this.sprintId).subscribe(
      sprint => {
        this.sprintData = sprint.data;
        if (isFormData) {
          this.getFormdata();
        }
      }
    );
  }

  openTimesheet(task) {
    this.taskId = task.id;
  }

  getSprintBoard() {
    this.projectsService.getSprintBoard(this.sprintId).subscribe(
      sprintBoard => {
        this.taskCount = 0;
        this.sprintBoard = sprintBoard.data;
        sprintBoard.data.forEach(element => {
          this.taskCount = this.taskCount + element.length
        });
      }, error => {

      }
    );
  }

  updateTask(item, status, event?) {
    this.projectsService.updateSprintBoard(this.sprintId, item, status).subscribe(
      sprintBoard => {
        this.getBacklogData(event);
      }, error => {
        this.getBacklogData(event);
      }
    );
  }

  updateSprintTime(event, object: any) {
    let body = {};
    body['sprint_id'] = object.id;
    body['type'] = object.type;
    body['new_time'] = event.value;
    this.projectsService.editTaskTimes(object.taskId, body).subscribe(
      res => {
        this.inlineEditorService.setValue(event);
        this.getSprint(true);
        this.alertService.success({ title: "SUCCESS", msg: "Time Updated Succesfully" });
      }
    );
  }

  getTimeLine() {
    this.projectsService.getTimeLine(this.projectId).subscribe(
      timeLine => {
        this.timeLine = timeLine.data;
      }
    );
  }

  /**
   * get all form data
   */
  getFormdata() {
    this.projectsService.getSprintFormData(this.sprintId, this.projectId).subscribe(
      formData => {
        this.formData = formData.data;
      }
    );    
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/components/sprint.component.ts